import React from 'react';
import { IPotentialMatch } from './IPotentialMatch';
import { Form, Formik } from 'formik';
import { IACHForm } from './Forms';
import { NumberField } from 'ui-toolkit/components/NumberField/NumberField';
import { depositCategoryOptions } from 'types/order/escrow/eDepositCategory';
import { SelectField } from 'ui-toolkit/components/SelectField/SelectField';
import { ePayerType } from 'types/order/escrow/ePayerType';
import { ButtonTW } from 'tailwindComponents/buttonTW/ButtonTW';
import { TextField } from 'ui-toolkit/components/TextField/TextField';
import { achPullPayerTypeOptions } from 'types/order/escrow/eAchPullPayerType';
import { IncomingACHValidationSchema } from 'components/order/fees/incomingFunds/IncomingAchDepositValidationSchema';

export interface IConfirmACHFormProps {
  potentialMatch: IPotentialMatch;
  createExpected: (x: IACHForm) => void;
  amountCents: number;
  amountCentsMax: number;
}

const stripPayerType = (data?: { payerType: ePayerType }) => {
  if (!data) return undefined;

  const { payerType, ...rest } = data;
  return rest;
};

export const ConfirmACHForm: React.FC<IConfirmACHFormProps> = ({
  potentialMatch,
  createExpected,
  amountCents,
  amountCentsMax,
}) => {
  const initialValuesConversion: IACHForm =
    stripPayerType(potentialMatch.expectedWire) ||
    stripPayerType(potentialMatch.expectedCheck) ||
    ({ amountCents } as IACHForm);

  const initialValues = {
    ...initialValuesConversion,
    version: 'v2-accounting',
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={createExpected}
      validationSchema={IncomingACHValidationSchema({ amountCentsMax })}
    >
      {({ values: { payerType } }) => (
        <Form>
          <div className={'text-left text-lg font-semibold'}>Please confirm expected ach information</div>
          <div className={'flex flex-row gap-1 pb-4 pt-2'}>
            <TextField
              className={`basis-48`}
              name={`wellsFargoTransactionNumber`}
              placeholder='StreetAddress-Zip (ex "123MainSt-90210")'
              label={'Memo'}
            />
            <NumberField
              className={`basis-36`}
              name={`amountCents`}
              mode="currency"
              placeholder="1,234.56"
              valueIsCents
              label={'Amount'}
            />
            <SelectField
              className={`basis-60 text-left`}
              name={`category`}
              options={depositCategoryOptions}
              label={'Category'}
            />
            <SelectField
              className={`basis-48 text-left`}
              name={`payerType`}
              options={achPullPayerTypeOptions}
              label={'Payer Type'}
            />

            <div className={'basis-28 self-end'}>
              <ButtonTW type={'submit'}>Save</ButtonTW>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
